import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { cn } from '@/lib/utils'

const EMPTY_VALUE = '__fde_select_empty__'

export interface FdeSelectOption {
  value: string
  label: string
  disabled?: boolean
}

interface Props {
  value: string
  options: FdeSelectOption[]
  onValueChange: (value: string) => void
  placeholder?: string
  ariaLabel?: string
  disabled?: boolean
  required?: boolean
  size?: 'sm' | 'default'
  className?: string
  contentClassName?: string
}

/**
 * Forge select built on the Workstation Radix primitive. Its portalled content
 * participates in Radix's nested layers, so choosing an option inside a dialog
 * does not dismiss the parent dialog.
 */
export default function FdeSelect({ value, options, onValueChange, placeholder, ariaLabel, disabled, required, size = 'default', className, contentClassName }: Props) {
  const hasEmptyOption = options.some((option) => option.value === '')
  const normalizedValue = value === '' ? (hasEmptyOption && !required ? EMPTY_VALUE : undefined) : value

  return <Select value={normalizedValue} disabled={disabled} required={required} onValueChange={(next) => onValueChange(next === EMPTY_VALUE ? '' : next)}>
    <SelectTrigger size={size} aria-label={ariaLabel} className={cn('w-full', className)}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className={contentClassName}>
      {options.map((option) => <SelectItem key={option.value || EMPTY_VALUE} value={option.value || EMPTY_VALUE} disabled={option.disabled}>{option.label}</SelectItem>)}
    </SelectContent>
  </Select>
}
